export class ApiUrl {
  public static readonly PRODUCT_LIST = 'api/Product/List';
  public static readonly SALES_REPORT_EXPORT = 'api/Report/Export';
  public static readonly SALES_REPORT_CHART = 'api/report/chart';

  public static readonly CHANNEL_VERIFY = 'api/Channel/Verify';
}
